import { Icon } from '@iconify/react';
import { isIPenPlatformDomainEntity } from '@ipen-portal/plugin-common';
import { makeEntityContentWithToolbar } from '@ipen-portal/plugin-layout-react';

export const ProductListEntityContent = makeEntityContentWithToolbar({
  name: 'ProductListEntityContent',
  params: {
    filter: isIPenPlatformDomainEntity,
    icon: <Icon icon="ic:outline-article" />,
    loader: async () =>
      import('./components/ProductList').then(m => <m.ProductList />),
    path: '/products',
    title: 'Products',
    toolbarProps: {
      creationTemplateRef: 'ipen-product-docu',
    },
    wrapperProps: {
      kindFilter: 'system',
      typeFilter: 'product',
    },
  },
});
